export default "__VITE_ASSET__DgpPNZoe__"